var _path, _rect, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQrCodeScanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 1.66663H27.3334C27.8857 1.66663 28.3334 2.11434 28.3334 2.66663V8.33329M8.33341 1.66663H2.66675C2.11446 1.66663 1.66675 2.11434 1.66675 2.66663V8.33329M1.66675 21.6666V27.3333C1.66675 27.8856 2.11446 28.3333 2.66675 28.3333H8.33341M28.3334 21.6666V27.3333C28.3334 27.8856 27.8857 28.3333 27.3334 28.3333H21.6667",
    stroke: "#808080",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.16675,
    y: 6.16663,
    width: 7,
    height: 7,
    rx: 0.5,
    stroke: "#808080"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.8335,
    y: 6.16663,
    width: 7,
    height: 7,
    rx: 0.5,
    stroke: "#808080"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.16675,
    y: 16.8333,
    width: 7,
    height: 7,
    rx: 0.5,
    stroke: "#808080"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.3335,
    y: 16.3333,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#808080"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeScanner);
export default __webpack_public_path__ + "static/media/qr-code-scanner.1b81d98d0eaca7444f34cc7d92335d56.svg";
export { ForwardRef as ReactComponent };